import React, {ChangeEvent} from 'react';

import {Choice, FieldProp} from '../../types';
import ReactDatepicker from "react-datepicker";

type RadioProps = FieldProp & {};

export const Radio: React.FunctionComponent<RadioProps> = ({
                                                                     field,
                                                                     fieldState,
                                                                     value = [],
                                                                     displayOnly,
                                                                     onChange,
                                                                     onBlur,
                                                                 }): JSX.Element => {
    const {touched, pristine, valid, invalid, errors} = fieldState;

    const classNames = [
        'form-check-input',
        touched && 'is-touched',
        pristine && 'is-pristine',
        valid && 'is-valid',
        invalid && 'is-invalid',
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <div>
            {field.choices && field.choices.map((choice: Choice, index: number) => {
                const isChecked = (value && value.value === choice.value);
                if (displayOnly && !isChecked) return;

                return (
                    <div key={`${field.id}-${index}`}
                         className="form-check form-check-inline">
                        {displayOnly ?
                            isChecked && <div>{choice.text.replace('&amp;', '&')}</div>
                            :
                            <div>
                                <input
                                    id={`${field.id}-${index}`}
                                    className={classNames}
                                    type="radio"
                                    value={choice.value}
                                    checked={isChecked}
                                    onBlur={() => {onBlur && onBlur()}}
                                    onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                        if (e.target.checked) {
                                            onChange(choice);
                                        }
                                    }}
                                />
                                <label className="form-check-label" htmlFor={`${field.id}-${index}`}>
                                    {choice.text.replace('&amp;', '&')}
                                </label>
                            </div>
                        }
                    </div>
                )
            })}

            {errors && errors.map((error: string, index: number) => (
                <div key={index} className="invalid-feedback">
                    {error}
                </div>
            ))}
        </div>
    );
};

